(() => {
  const root = document.documentElement;
  const liveRegion = document.getElementById("LiveRegion");
  const announce = (message) => {
    if (liveRegion) liveRegion.textContent = message;
  };

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-open-dialog]");
    if (opener) {
      event.preventDefault();
      const dialog = document.getElementById(opener.dataset.openDialog);
      if (dialog?.showModal) {
        dialog.showModal();
        dialog.dataset.opener = opener.id || "";
        opener.setAttribute("aria-expanded", "true");
        dialog.querySelector("[data-initial-focus]")?.focus();
      }
    }
    const closer = event.target.closest("[data-close-dialog]");
    if (closer) {
      const dialog = closer.closest("dialog");
      dialog?.close();
    }
    if (event.target.nodeName === "DIALOG") event.target.close();
  });

  document.querySelectorAll("dialog").forEach((dialog) => {
    dialog.addEventListener("close", () => {
      const opener =
        dialog.dataset.opener && document.getElementById(dialog.dataset.opener);
      opener?.setAttribute("aria-expanded", "false");
      opener?.focus();
    });
  });

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector("[data-predictive-results]");
      if (!this.input || !this.results) return;
      let timer;
      this.input.addEventListener("input", () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.search(), 180);
      });
      this.input.addEventListener("keydown", (event) => this.onKeydown(event));
      this.results.addEventListener("keydown", (event) =>
        this.onKeydown(event),
      );
    }
    async search() {
      const query = this.input.value.trim();
      if (query.length < 2) {
        this.results.innerHTML = "";
        this.input.removeAttribute("aria-activedescendant");
        return;
      }
      this.setAttribute("aria-busy", "true");
      try {
        const url = `${window.Shopify?.routes?.root || "/"}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,query&resources[limit]=8&section_id=predictive-search`;
        const response = await fetch(url);
        if (!response.ok) throw new Error("Search request failed");
        const text = await response.text();
        const html = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search");
        this.results.innerHTML = html?.innerHTML || "";
        announce(
          `${this.results.querySelectorAll('[role="option"]').length} suggestions available.`,
        );
      } catch (_) {
        this.results.innerHTML = "";
      } finally {
        this.removeAttribute("aria-busy");
      }
    }
    onKeydown(event) {
      const options = [...this.results.querySelectorAll('[role="option"] a')];
      if (!options.length) return;
      const current = options.indexOf(document.activeElement);
      if (event.key === "ArrowDown") {
        event.preventDefault();
        options[Math.min(current + 1, options.length - 1)].focus();
      }
      if (event.key === "ArrowUp") {
        event.preventDefault();
        (current <= 0 ? this.input : options[current - 1]).focus();
      }
      if (event.key === "Escape") {
        this.results.innerHTML = "";
        this.input.focus();
      }
    }
  }
  customElements.define("predictive-search", PredictiveSearch);

  document.addEventListener("change", (event) => {
    if (event.target.matches("[data-auto-submit]"))
      event.target.form?.requestSubmit();
  });
  document.addEventListener("click", (event) => {
    const toggle = event.target.closest("[data-toggle-facets]");
    if (toggle) {
      const facets = document.getElementById("CollectionFacets");
      facets?.classList.toggle("is-open");
      toggle.setAttribute(
        "aria-expanded",
        facets?.classList.contains("is-open") ? "true" : "false",
      );
    }
  });

  document.addEventListener("shopify:section:load", () =>
    announce("Section updated."),
  );
})();
